import React, { useContext } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Col, Container, Row } from "reactstrap";
import EmailParsers from "./EmailParsers";
import { ThemeContext } from "src/helpers/themeContext";

const EmailParsersPage = () => {
    const Theme = useContext(ThemeContext)
    return (
        
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Email Parsers | {Theme.name} email parsers</title>
                </MetaTags>

                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Home" breadcrumbItem="Email Parsers" />

                    <Row>
                        <Col lg={12}>
                            <EmailParsers />
                        </Col>
                    </Row>

                    
                </Container>
            </div>
        </React.Fragment>
    );
}

export default EmailParsersPage;